import React from 'react'

export default function Attendance() {
  return (
    <div>
      Attendance
    </div>
  )
}
